




























import Vue from 'vue'
import InAppPurchase from '@/inapp-purchase'
import { sleep } from '@/utils/helpers'

export default Vue.extend({
  name: 'Ask',
  data() {
    return {
      iap: null,
      loading: null
    }
  },
  computed: {
    mightRestore(): boolean {
      return this.$_hasCordova && this.$store.getters['MyData/isMan']
    }
  },
  destroyed() {
    if (this.iap) {
      this.iap.off('ready', this.handleReady)
    }
    if (this.loading) {
      this.loading.close()
    }
  },
  methods: {
    async ask() {
      location.href = await this.$_mailTo
    },

    /**
     * アプリ課金のリストア
     */
    async restore() {
      if (!this.mightRestore) {
        return
      }

      this.loading = this.$loading.open({ isFullPage: true })
      this.iap = new InAppPurchase()
      const data = await this.iap.fetchAppPayment().catch(async err => {
        console.error(err)
        await this.$_alert(err)
        this.$router.back()
      })

      this.iap.init(data.menus)
      this.iap.on('ready', this.handleReady)
    },

    /**
     * store のリストアが完了した
     */
    async handleReady() {
      // デバッグ版では iOS で store.refresh() を複数回呼び出すと iTunes のサインインダイアログが表示されてしまう
      // https://github.com/j3k0/cordova-plugin-purchase/wiki/F.A.Q.#products-wont-load-invalid-product-id
      store.refresh()
      await sleep(3000)
      this.loading.close()
      this.$_alert('購入を復元しました')
    }
  }
})
